import React from 'react';
import AtelierImage from '../assets/atelier-info/atelier-jenny-info-3.jpeg'

const AtelierInfo = () => {

    return (
      <div className="flex flex-col md:flex-row items-center md:items-start justify-center md:justify-between py-16 md:py-24">
      
      {/* Left Column: Image */}
      <div className="w-full md:w-5/6 h-full ">
        <img
          src={AtelierImage}
          alt="Atelier Jenny Interior"
          className="w-full h-full object-cover rounded-md scale-y-125"
        />
      </div>
      
      {/* Right Column: Text and Button */}
      <div className="w-full md:w-1/2 p-8 pt-40 font-serif text-center md:text-left tracking-wider">
        <h2 className="text-2xl font-thin text-center  mb-4 opacity-50">Atelier Jenny</h2>
        <p className="text-gray-600 mb-4 text-center leading-loose">
        Στο Atelier Jenny σχεδιάζουμε και δημιουργούμε μοναδικά χειροποίητα Νυφικά και Βραδινά φορέματα, ανταποκρινόμενα στις επιθυμίες σας, λαμβάνοντας υπόψιν την κάθε προσωπικότητα και σωματότυπο, αναδεικνύοντας τη θηλυκότητα, την κομψότητα, τη γοητεία και την ομορφιά.
        </p>
        <p className="text-gray-600 mb-4 text-center leading-loose">
        Με μεγάλη ποικιλία σχεδίων, με υψηλής ποιότητας υφασμάτων και υλικών, με άριστη τεχνική και ραφή, αλλά και με πολλή φαντασία και αγάπη, στο Atelier Jenny μπορούμε να κάνουμε πραγματικότητα το Νυφικό φόρεμα των ονείρων σας.
        </p>
      </div>
    </div>
    );
  };
  
  export default AtelierInfo;